/**
 * Campus catalog for the v2 admin.
 *
 * Unlike v1, no Firebase/Odoo secrets live in the frontend. The backend NestJS app
 * owns ERP credentials per campus and mounts every campus-aware controller under
 * `/api/v1/:campus/...`. We only need slug + display label here.
 *
 * Slug values MUST match the backend `CampusSlug` union
 * (`src/shared/crm-sdk/types/campus.types.ts` in mindtalk-doctors-backend).
 */

export const CAMPUS_SLUGS = ["mindtalk", "cadabams", "mysore", "whitefield"];

export const CAMPUSES = {
  mindtalk: { slug: "mindtalk", label: "Mindtalk" },
  cadabams: { slug: "cadabams", label: "Cadabams (Hospital)" },
  mysore: { slug: "mysore", label: "Mysore" },
  whitefield: { slug: "whitefield", label: "Whitefield" },
};

export function getCampusList() {
  return CAMPUS_SLUGS.map((slug) => CAMPUSES[slug]);
}

export function isValidCampus(slug) {
  return Boolean(slug && CAMPUSES[slug]);
}

export const DEFAULT_CAMPUS =
  process.env.REACT_APP_DEFAULT_CAMPUS && isValidCampus(process.env.REACT_APP_DEFAULT_CAMPUS)
    ? process.env.REACT_APP_DEFAULT_CAMPUS
    : "mindtalk";
